import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { COLORS } from '@constants/colors';
import { Box, Button, useTheme } from '@mui/material';
export const VoiceSampleActionsFooter = ({ onRestart, onUpload, isUploading, }) => {
    const theme = useTheme();
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { sx: {
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: { xs: theme.spacing(18), md: theme.spacing(12) },
                    boxShadow: COLORS.shadow.actionFooter,
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    justifyContent: { xs: 'space-between', md: 'flex-end' },
                    gap: { xs: 0, md: theme.spacing(2) },
                    p: theme.spacing(2),
                    alignItems: { xs: 'stretch', md: 'center' },
                    backgroundColor: theme.palette.background.default,
                    zIndex: theme.zIndex.drawer + 1,
                }, children: [_jsx(Button, { disabled: isUploading, variant: "outlined", onClick: () => onRestart(), children: "Restart Recording" }), _jsx(Button, { disabled: isUploading, variant: "contained", color: "primary", onClick: () => onUpload(), children: "Upload Voice Sample" })] }), _jsx(Box, { sx: { height: theme.spacing(12) } })] }));
};
